import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-party-parameter-mapping',
  templateUrl: './party-parameter-mapping.component.html',
  styleUrls: ['./party-parameter-mapping.component.scss']
})
export class PartyParameterMappingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
